import { ToggleButton } from "@transfr-inc/dashboard-components/forms";
import Skeleton from "react-loading-skeleton";

export const SecureModeToggle = ({ value, onChange, loading }) => {
  if (loading) {
    return <Skeleton rounded height="32px" width="100%" />;
  }

  return (
    <div className="secure-mode-toggle">
      <ToggleButton value={value} onChange={onChange} />
      <span>
        Removes the option to share a career plan by email and disables external
        links.
      </span>
    </div>
  );
};
